import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import {
  categoryAdd,
  categoryList,
  updatecategoryName,
  updateCategoryStatus,
  updateCategoryToggle,
} from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { Section } from "../../Core/Section";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { logDOM } from "@testing-library/dom";

const Category = () => {
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [category, setCategory] = useState([]);
  const [categoryUpdated, setCategoryUpdated] = useState(false);
  const [formData, setFormData] = useState({
    productCategoryName: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [editModal,setEditModal]=useState(false)
  const [selectedCategory, setSelectedCategory] = useState(null);
  const[catName,setCatName]=useState("")

        const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 10;
      
      const indexOfLast = currentPage * itemsPerPage;
      const indexOfFirst = indexOfLast - itemsPerPage;
      
      const currentUsers = category?.slice(indexOfFirst, indexOfLast);

  const handleViewDetails = (category) => {
    setSelectedCategory(category);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCategory(null);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await categoryAdd(formData,token);
      console.log("response:", response);
      if (response.status === 200) {
        toast.success("Category added successfully");
        setCategoryUpdated((prev) => !prev);
      } else {
        console.log("don", response.data.message);
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };


 const fetchCategoryList = async () => {
      try {
        const response = await categoryList(token);
        console.log("category list:", response);
        setCategory(response);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

  useEffect(() => {
   

    fetchCategoryList();
  }, [categoryUpdated]);


  const handleEdit=(category)=>{
    setEditModal(true)
    setCatName(category.productCategoryName)
    setSelectedCategory(category)


  }
  const toggleOnlineStatus = async (id) => {
    try {
      const response = await updateCategoryStatus(id,token);
      console.log("online status :", response);
      if (response.data.status === "success") {
        setCategoryUpdated((prev) => !prev);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const toggleStatus = async (id) => {
    try {
      const response = await updateCategoryToggle(id,token);
      console.log("toggle status :", response);
      if (response.data.status === "success") {
        setCategoryUpdated((prev) => !prev);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleUpdateCatName=async()=>{
    try {
      let data={
        id:selectedCategory.id,
        categoryname:catName,
        onlineAvlaible:selectedCategory.onlineAvlaible,
        status:selectedCategory.status
      }
      const res=await updatecategoryName(data,token)
      console.log(res);

      fetchCategoryList()
      setEditModal(false)
      
      
    } catch (error) {
      console.log(error);
      toast.error("Failed to update name")
    }
  }

  return (
    <div id="main_content">
      <Header />
      <div className="page">
       
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Category</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Category
                  </li>
                </ol>
              </div>
              <ul className="nav nav-tabs page-header-tab">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#Category-all"
                  >
                    List View
                  </a>
                </li>
               
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#Category-add"
                  >
                    Add
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Category-all">
                {/* <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Roll No."
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Department"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            data-provide="datepicker"
                            data-date-autoclose="true"
                            className="form-control"
                            placeholder="Admission Date"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <a
                          href="javascript:void(0);"
                          className="btn btn-sm btn-primary btn-block"
                          title
                        >
                          Search
                        </a>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th style={{textAlign:"center"}}>Id</th>
                    
                        <th style={{textAlign:"center"}} >Product Category Name</th>
                        <th style={{textAlign:"center"}}>Online Status</th>
                        <th style={{textAlign:"center"}}>Status</th>
                        <th style={{textAlign:"center"}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers?.map((category,index) => (
                        <tr key={category?.id}>
                          <td>{index+1}</td>
                        
                          <td>{category?.productCategoryName}</td>
                          <td>
                            <button
                              className={`btn btn-sm ${
                                category?.onlineAvlaible
                                  ? "btn-primary"
                                  : "btn-danger"
                              }`}
                              onClick={() => toggleOnlineStatus(category?.id)}
                            >
                              {category?.onlineAvlaible ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td>
                            <button
                              className={`btn btn-sm ${
                                category?.status ? "btn-primary" : "btn-danger"
                              }`}
                              onClick={() => toggleStatus(category?.id)}
                            >
                              {category?.status ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="View"
                              onClick={() => handleViewDetails(category)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-sm"
                              title="Edit"
                              onClick={()=>handleEdit(category)}
                            >
                              <i className="fa fa-edit" />
                            </button>
                            
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                                           <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(category.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(category
      
      
      .length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
</div>
                </div>
              </div>
             
              <div className="tab-pane" id="Category-add">
                <div className="row clearfix">
                  <div className="col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Basic Information</h3>
                        <div className="card-options ">
                          
                        </div>
                      </div>
                      <form className="card-body" onSubmit={handleSubmit}>
                        <div className="form-group row">
                          <label className="col-md-3 col-form-label">
                            Product Category Name{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <input
                              type="text"
                              className="form-control"
                              name="productCategoryName"
                              placeholder="Enter Category name"
                              value={formData.productCategoryName}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  {/* <div className="col-lg-4 col-md-12 col-sm-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Account Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row clearfix">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>User Name</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Password</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label>Confirm Password</label>
                              <input type="text" className="form-control" />
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <button type="submit" className="btn btn-primary">
                              Submit
                            </button>
                            <button
                              type="submit"
                              className="btn btn-outline-secondary"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Account Information</h3>
                        <div className="card-options ">
                          <a
                            href="#"
                            className="card-options-collapse"
                            data-toggle="card-collapse"
                          >
                            <i className="fe fe-chevron-up" />
                          </a>
                          <a
                            href="#"
                            className="card-options-remove"
                            data-toggle="card-remove"
                          >
                            <i className="fe fe-x" />
                          </a>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="form-group">
                          <label>Facebook</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>Twitter</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>LinkedIN</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>Behance</label>
                          <input type="text" className="form-control" />
                        </div>
                        <div className="form-group">
                          <label>dribbble</label>
                          <input type="text" className="form-control" />
                        </div>
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                        <button
                          type="submit"
                          className="btn btn-outline-secondary"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal for cat Details */}
        <Modal show={showModal} onHide={handleCloseModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Category Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedCategory ? (
              <div>
                <p>
                  <strong>ID:</strong> {selectedCategory.id}
                </p>
                <p>
                  <strong>Category Name:</strong>{" "}
                  {selectedCategory.productCategoryName}
                </p>
                <p>
                  <strong>Online Available:</strong>{" "}
                  {selectedCategory.onlineAvlaible ? "Active" : "Inactive"}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  {selectedCategory.status ? "Active" : "Inactive"}
                </p>
              </div>
            ) : (
              <p>No details available</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>


        {/* modal for edit category */}
        <Modal show={editModal} onHide={()=>setEditModal(false)} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Category edit</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedCategory ? (
              <div>
                <p>
                  <strong>ID:</strong> {selectedCategory.id}
                </p>
                <p>
                  <strong>Category Name:</strong>{" "}
                  <input value={catName}
                  onChange={(e)=>{
                    setCatName(e.target.value)
                  }}
                  />
                </p>
                
               
              </div>
            ) : (
              <p>No details available</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleUpdateCatName}>
             Update
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default Category;
